<template>
    <b-card class="card-objective" no-body>

        <div class="header">
          <h5>
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>                
              {{title}}
            </PuSkeleton>            
          </h5>
          <PuSkeleton :loading="isLoading" width="60px">                
            <span class="allnumber">{{allNumber}}</span>
          </PuSkeleton>
        </div>

        <PuSkeleton :loading="isLoading" :count="1" height="25px">
          <div class="title mb-2">
            <h4>{{resultOne}}</h4>
            <div class="result"  :class="{negative : isNegative}">
              {{differences}}
            </div>          
          </div>
        </PuSkeleton>

        <PuSkeleton :loading="isLoading" :count="1"  height="40px">
          <div class="line">
            <b-progress height="1.75rem" :value="value" :max="max" class="positive" :class="{negative : isNegative}">
            </b-progress>

            <div class="date">
              {{date}}
            </div>

            <div class="pourcentYear" :style="{left: pourcentYear + '%'}"></div>
          </div>
        </PuSkeleton>

    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardObjective",
  components:{ 
  },
  mixins: [card],
  props:{
    title:{
      type:String,
      default:'Epargne'
    },
    allNumber:{
      type:String,
      default:'125 000'
    },
    resultOne:{
      type:String,
      default:'56 000'
      },
    differences:{
      type:String,
      default:'+5 000'
      },
    date:{
      type:String,
      default:'20 mars 2020'
    }
  },
  data(){
    return {
        isLoading:true,
    }
  },
  methods : {
  },  
  mounted (){
    this.getPourcent(this.resultOne);
    this.getPourcentByYear();
    this.getNegatifOrNot(this.differences);
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>